import {cn} from 'platform/shared-tw';

import {partFill, partStroke, type DiagramVariant} from '../shared/partVariants';

interface RearRightSideshaftProps {
  variant?: DiagramVariant;
  onClick?: () => void;
}

export function RearRightSideshaft(props: RearRightSideshaftProps) {
  return (
    <svg
      width="38"
      height="75"
      viewBox="0 0 38 75"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute [pointer-events:none] cursor-pointer group"
      style={{top: 147, right: 283}}
      onClick={props.onClick}
    >
      <path
        d="M35 69C35 69 37 69 37 71V74H1V71C1.00002 69 3 69 3 69H7V65H5C5 65 3.00001 65 3 63V61C3.00001 59 5 59 5 59H11C11 59 9 59 9 57C9.00001 55 11 55 11 55H13C13 55 11 55 11 53C11 51 13 51 13 51H15C15 51 13 51 13 49C13 47 15 47 15 47V1H23V47C23 47 25 47 25 49C25 51 23 51 23 51H25C25 51 27 51 27 53C27 55 25 55 25 55H27C27 55 29 55 29 57C29 59 27 59 27 59H33C33 59 35 59 35 61V63C35 65 33 65 33 65H31V69H35Z"
        fill="currentColor"
        className={cn(partFill({variant: props.variant}))}
      ></path>
      <path
        d="M23 47V1H15V47H23Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M23 47H19H15C15 47 13 47 13 49C13 51 15 51 15 51H19H23C23 51 25 51 25 49C25 47 23 47 23 47Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M25 51H19H13C13 51 11 51 11 53C11 55 13 55 13 55H19H25C25 55 27 55 27 53C27 51 25 51 25 51Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M27 55H19H11C11 55 9 55 9 57C9 59 11 59 11 59H19H27C27 59 29 59 29 57C29 55 27 55 27 55Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M33 65H19H5C5 65 3 65 3 63V62V61C3 59 5 59 5 59H19H33C33 59 35 59 35 61V62V63C35 65 33 65 33 65Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <path
        d="M35 69H19H3C3 69 1 69 1 71V74H37V71C37 69 35 69 35 69Z"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
      <rect
        width="24"
        height="4"
        transform="matrix(1 0 0 -1 7 69)"
        stroke="currentColor"
        className={partStroke({variant: props.variant})}
        strokeWidth="2"
      />
    </svg>
  );
}
